
import { supabase } from "@/integrations/supabase/client";
import { Message } from "@/types/chat";
import { RealtimeChannel } from "@supabase/supabase-js";

export function useMessageSubscription(
  conversationId: string | null,
  onNewMessage: (message: Message) => void
) {
  const setupRealtimeSubscription = (): RealtimeChannel | null => {
    if (!conversationId) {
      console.log('No conversation ID provided for subscription');
      return null;
    }

    try {
      console.log('Setting up realtime subscription for conversation:', conversationId);
      
      // Create a stable channel name
      const channelName = `chat_messages_${conversationId}`;
      
      // Remove any existing subscription to prevent duplicates
      const existingChannel = supabase.getChannels().find(channel => 
        channel.topic === channelName
      );
      
      if (existingChannel) {
        console.log('Removing existing subscription');
        supabase.removeChannel(existingChannel);
      }

      const channel = supabase
        .channel(channelName)
        .on(
          'postgres_changes',
          {
            event: 'INSERT',
            schema: 'public',
            table: 'chat_messages',
            filter: `conversation_id=eq.${conversationId}`,
          },
          (payload) => {
            console.log('Received new message payload:', payload);
            if (payload.new) {
              const newMessage = {
                ...payload.new,
                role: payload.new.role as 'user' | 'assistant'
              } as Message;
              onNewMessage(newMessage);
            }
          }
        )
        .subscribe((status) => {
          console.log('Subscription status:', status);
          if (status === 'SUBSCRIBED') {
            console.log('Successfully subscribed to chat messages');
          } else if (status === 'CLOSED') {
            console.log('Subscription closed');
          } else if (status === 'CHANNEL_ERROR') {
            console.error('Channel error occurred');
          }
        });

      return channel;
    } catch (error) {
      console.error('Error setting up realtime subscription:', error);
      return null;
    }
  };

  return {
    setupRealtimeSubscription,
  };
}
